"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var sigmoid_1 = __importDefault(require("./sigmoid"));
var connection_1 = __importDefault(require("./connection"));
var layer_1 = __importDefault(require("./layer"));
var Network = /** @class */ (function () {
    function Network(numberOfLayers) {
        this.layers = numberOfLayers.map(function (length, index) {
            var layer = new layer_1.default(length);
            if (index !== 0) {
                layer.neurons.forEach(function (neuron) {
                    neuron.setBias(neuron.getRandomBias());
                });
            }
            return layer;
        });
        this.learningRate = 0.3; // multiply's against the input and the delta then adds to momentum
        this.momentum = 0.1; // multiply's against the specified "change" then adds to learning rate for change
        this.iterations = 0;
        this.connectLayers();
    }
    Network.prototype.toJSON = function () {
        return {
            learningRate: this.learningRate,
            iterations: this.iterations,
            layers: this.layers.map(function (l) { return l.toJSON(); })
        };
    };
    Network.prototype.setLearningRate = function (value) {
        this.learningRate = value;
    };
    Network.prototype.setIterations = function (val) {
        this.iterations = val;
    };
    Network.prototype.connectLayers = function () {
        for (var layer = 1; layer < this.layers.length; layer++) {
            var thisLayer = this.layers[layer];
            var prevLayer = this.layers[layer - 1];
            for (var neuron = 0; neuron < prevLayer.neurons.length; neuron++) {
                for (var neuronInThisLayer = 0; neuronInThisLayer < thisLayer.neurons.length; neuronInThisLayer++) {
                    var connection = new connection_1.default(prevLayer.neurons[neuron], thisLayer.neurons[neuronInThisLayer]);
                    prevLayer.neurons[neuron].addOutputConnection(connection);
                    thisLayer.neurons[neuronInThisLayer].addInputConnection(connection);
                }
            }
        }
    };
    // When training we will run this set of functions each time
    Network.prototype.train = function (input, output) {
        this.activate(input);
        // Forward propagate
        this.runInputSigmoid();
        // backpropagate
        this.calculateDeltasSigmoid(output);
        this.adjustWeights();
        // console.log(this.layers.map(l => l.toJSON()))
        this.setIterations(this.iterations + 1);
    };
    Network.prototype.activate = function (values) {
        this.layers[0].neurons.forEach(function (n, i) {
            n.setOutput(values[i]);
        });
    };
    Network.prototype.run = function () {
        // For now we only use sigmoid function
        return this.runInputSigmoid();
    };
    Network.prototype.runInputSigmoid = function () {
        for (var layer = 1; layer < this.layers.length; layer++) {
            for (var neuron = 0; neuron < this.layers[layer].neurons.length; neuron++) {
                var bias = this.layers[layer].neurons[neuron].bias;
                // For each neuron in this layer we compute its output value
                var connectionsValue = this.layers[layer].neurons[neuron].inputConnections.reduce(function (prev, conn) {
                    var val = conn.weight * conn.from.output;
                    return prev + val;
                }, 0);
                this.layers[layer].neurons[neuron].setOutput((0, sigmoid_1.default)(bias + connectionsValue));
            }
        }
        return this.layers[this.layers.length - 1].neurons.map(function (n) { return n.output; });
    };
    Network.prototype.calculateDeltasSigmoid = function (target) {
        for (var layer = this.layers.length - 1; layer >= 0; layer--) {
            var currentLayer = this.layers[layer];
            for (var neuron = 0; neuron < currentLayer.neurons.length; neuron++) {
                var currentNeuron = currentLayer.neurons[neuron];
                var output = currentNeuron.output;
                var error = 0;
                if (layer === this.layers.length - 1) {
                    // Is output layer
                    error = target[neuron] - output;
                    // console.log('calculate delta, error, last layer', error)
                }
                else {
                    // Other than output layer
                    for (var k = 0; k < currentNeuron.outputConnections.length; k++) {
                        var currentConnection = currentNeuron.outputConnections[k];
                        error += currentConnection.to.delta * currentConnection.weight;
                        // console.log('calculate delta, error, inner layer', error)
                    }
                }
                currentNeuron.setError(error);
                currentNeuron.setDelta(error * output * (1 - output));
            }
        }
    };
    Network.prototype.adjustWeights = function () {
        for (var layer = 1; layer <= this.layers.length - 1; layer++) {
            var prevLayer = this.layers[layer - 1];
            var currentLayer = this.layers[layer];
            for (var neuron = 0; neuron < currentLayer.neurons.length; neuron++) {
                var currentNeuron = currentLayer.neurons[neuron];
                var delta = currentNeuron.delta;
                for (var i = 0; i < currentNeuron.inputConnections.length; i++) {
                    var currentConnection = currentNeuron.inputConnections[i];
                    var change = currentConnection.change;
                    change = (this.learningRate * delta * currentConnection.from.output)
                        + (this.momentum * change);
                    currentConnection.setChange(change);
                    currentConnection.setWeight(currentConnection.weight + change);
                }
                currentNeuron.setBias(currentNeuron.bias + (this.learningRate * delta));
            }
        }
    };
    return Network;
}());
exports.default = Network;
